import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Question from './Question';
import * as Answer from './Answer';
import FeedbackMessage from './FeedbackMessage';
import Fraction from '@/Components/Fraction';

export default function TestFormUI(props) {
    const { register, handleSubmit, watch } = useForm();

    function renderQuestionsAnswers(parentQuestions, parentIndex, previousQuestionNumber) {
        let questions = parentQuestions ? parentQuestions : props.questions;
        if (!previousQuestionNumber) previousQuestionNumber = 1;

        let renderedQuestions = questions.map((question, i) => {
            let key = parentIndex === undefined ? i : parentIndex + '-' + i;
            let rendered;

            if (question.questions === undefined) {
                let questionColumnClass = "col-12";
                let gradeColumn = undefined;

                if (props.isTestResults) {
                    questionColumnClass = "col-12 col-md-9";
                    let score = props.initialValues['score_' + question.id];
                    let status;

                    if (score === null || score === undefined) {
                        status = props.isPreview ? 'Preview Only' : 'Waiting for Grade';
                    }

                    gradeColumn = (
                        <div className="col-12 col-md-3">
                            <Fraction status={status} x={score} y={question.points} unit={question.points === 1 ? 'pt' : 'pts'} />
                        </div>
                    );
                }

                rendered = (
                    <div key={key} className="question-container row">
                        <div className={questionColumnClass}>
                            <Question
                                question={question.text}
                                image={question.image}
                                imageAltText={question.image_alt_text || ''}
                                questionNumber={previousQuestionNumber}
                                points={question.points}
                                inGroup={parentIndex !== undefined}
                                isTestResults={props.isTestResults || false}
                            />
                            {renderAnswerInput(question)}
                            {renderFeedback(question)}
                        </div>
                        {gradeColumn}
                    </div>
                );
            } else {
                rendered = (
                    <div key={i} className="question-group">
                        {renderQuestionGroupContent(question)}
                        {renderQuestionsAnswers(question.questions, i, previousQuestionNumber)}
                    </div>
                );

                previousQuestionNumber += question.questions.length - 1;
            }

            let hr = !parentQuestions && i < questions.length - 1 ? <hr key={'hr-' + i} /> : undefined;

            rendered = [rendered];
            if (hr) rendered.push(hr);

            previousQuestionNumber++;
            return rendered;
        });

        return renderedQuestions;
    }

    function renderQuestionGroupContent(question) {
        let imageRow;

        if (question.image) {
            imageRow = (
                <div className="row">
                    <div className="col-12 d-flex justify-content-center">
                        <a href={question.image} target="_blank">
                            <img className="question-group-image img-fluid" src={question.image} />
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div className="question-group-text-container">
                <div className="row">
                    <div className="col-12">
                        <div className="question-group-text" dangerouslySetInnerHTML={{__html: question.text}} />
                    </div>
                </div>
                {imageRow}
            </div>
        );
    }

    function renderAnswerInput(question) {
        let answerType;

        if (question.type === 'multiple_choice') {
            answerType = 'RadioOptionList';
        } else {
            answerType = 'TextEntry';
        }

        let AnswerInputClass = Answer[answerType];
        let questionId = 'question_' + question.id;

        return (
            <div className="answer">
                <AnswerInputClass
                    answerOptions={question.answers}
                    questionId={questionId}
                    disabled={props.isTestResults}
                    initialValues={props.initialValues}
                    value={props.initialValues[questionId]}
                    isTestResults={props.isTestResults || false}
                    register={register}
                />
            </div>
        );
    }

    function renderOverallFeedback() {
        let message = props.initialValues['overall_feedback'];
        if (!message) return;
        return <FeedbackMessage message={message} />;
    }

    function renderFeedback(question) {
        let message = props.initialValues['feedback_' + question.id];
        if (!message) return;
        return <FeedbackMessage message={message} />;
    }

    useEffect(() => {
        const subscription = watch(props.onFormUpdate);

        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <form onSubmit={handleSubmit(props.onSubmit)}>
            {renderOverallFeedback()}
            {renderQuestionsAnswers()}
            <button ref={props.submitButtonRef} className="d-none" type='submit'>Submit</button>
        </form>
    );
}
